/** Racial production halls and monster camps — STRUCT_ART indices 9..25, all 24x24. */
export const ART_BUILDINGS_RACIAL: string[][][] = [
  /* 9 Barracks (human) — timber-framed drill hall, pitched slate roof, iron-studded door, spear racks, square banner */
  [
    [
      '           m            ',
      '           #PPPPP       ',
      '           #PPPPP       ',
      '           #ppppp       ',
      '           #PPpp        ',
      '           #            ',
      '          #dd#          ',
      '         #dmmd#         ',
      '        #ddmmdd#        ',
      '       #dddmmddd#       ',
      '      #ddddmmdddd#      ',
      '     #dddddmmddddd#     ',
      '   bbbbbbbbbbbbbbbbbb   ',
      '    wwwwwwwwwwwwwwww    ',
      '    nn#nnnnnnnnnn#nn    ',
      '    nN#NNnnnnnnNN#Nn    ',
      '    nNNNNnPPPPnNNNNn    ',
      '    nnmNnwwwwwwnNmnn    ',
      '    nnmNnwbbbbwnNmnn    ',
      '    nnmnnwbbbbwnnmnn    ',
      '    nNmnnwbmmbwnnmNn    ',
      '    nnmnnwbbbbwnnmnn    ',
      '    nnmnnwbbbbwnnmnn    ',
      '   nNNNNNNNNNNNNNNNNn   ',
    ],
  ],
  /* 10 Thieves' Den (human) — sagging tiled roof, crooked chimney, boarded window, barrel, hanging sign */
  [
    [
      '                        ',
      '     ooo                ',
      '    oo o                ',
      '     #nn#               ',
      '     #nn#               ',
      '     #nn#               ',
      '     #nn#               ',
      '      #bbbbbbbbbb#      ',
      '     #bqbbbbbbbbqb#     ',
      '    #bbqbbbbbbbbqbb#    ',
      '   #bbbqbbbbbbbbqbbb#   ',
      '  ##bbbbbbbbbbbbbbbb##  ',
      '  #oooooooooooooooooo#  ',
      '    wwwwwwwwwwwwwwww    ',
      '    n#qq#nnnnn#PP#nn    ',
      '    n#qq#nnnnn#pp#nn    ',
      '    n#qq#nNNNn#PP#nn    ',
      '    n####nNnnnn##nnn    ',
      '    nnnnnn####nnnnnn    ',
      '    nNnnn#oooo#nnnNn    ',
      '    nqqqn#oooo#nnnnn    ',
      '    nbbbn#oooo#nnnnn    ',
      '    nqqqn#oooo#nnnnn    ',
      '   onnnnnnnnnnnnnnnno   ',
    ],
  ],
  /* 11 Mage Tower (human) — square-cut ashlar spire, slate cone, crenellated gallery, arched arcane window, flat banner */
  [
    [
      '           c            ',
      '          cvc           ',
      '           #            ',
      '           ##           ',
      '          #dd#          ',
      '         #dddd#         ',
      '        #ddmmdd#        ',
      '       #dddmmddd#       ',
      '      #ddddmmdddd#      ',
      '     ##dddddddddd##     ',
      '     NNNNNNNNNNNNNN     ',
      '      nNnnnnnnnnNn      ',
      '       nNNNNNNNNn       ',
      '       nn#vvvv#nn       ',
      '       nn#vccv#nn       ',
      '       nn#vvvv#nn       ',
      '       nNnnnnnnNn       ',
      '       nn#PPPP#nn       ',
      '       nn#PPPP#nn       ',
      '       nn#pppp#nn       ',
      '      nnnnnnnnnnnn      ',
      '     nNNNNNNNNNNNNn     ',
      '    nnNNNNNNNNNNNNnn    ',
      '   nnnnnnnnnnnnnnnnnn   ',
    ],
  ],
  /* 12 Dragon Roost (human) — twin merlon turrets, timber landing platform jutting out, huge fire-lit arch */
  [
    [
      '    #              #    ',
      '    #PPP        PPP#    ',
      '    #ppp        ppp#    ',
      '    #              #    ',
      '   NnNn          NnNn   ',
      '   nNNn          nNNn   ',
      '   nnnnwwwwwwwwwwnnnn   ',
      '   nnnnbbbbbbbbbbnnnn   ',
      '   nnnnnnnnnnnnnnnnnn   ',
      '   nnnnn########nnnnn   ',
      '   nnnn#oooooooo#nnnn   ',
      '   nNnn#oorrrroo#nnNn   ',
      '   nnnn#orrrrrro#nnnn   ',
      '   nnnn#rryyyyrr#nnnn   ',
      '   nnnn#rrrrrrrr#nnnn   ',
      '   nnnn##########nnnn   ',
      'wwwnNNnnnnnnnnnnnnNNnwww',
      'bbbnnnnnnnnnnnnnnnnnnbbb',
      '   nnnNnn######nnNnnn   ',
      '   nnnNnn#wwww#nnNnnn   ',
      '   nnnnnn#wbbw#nnnnnn   ',
      '   nNnnnn#wbbw#nnnnNn   ',
      '   nnnnnn#wbbw#nnnnnn   ',
      '  nNNNNNNNNNNNNNNNNNNn  ',
    ],
  ],
  /* 13 Forge Hall (dwarf) — the WIDE LOW one. A full-bleed slab of a hall occupying
     only the bottom thirteen rows, with two thin brass-hooped chimneys standing
     clear above it: the silhouette is a long bar with two prongs and nothing else.
     Fire-lit mouth fourteen pixels across, anvil in it, kingdom banners flanking.
     Two frames: the fire and smoke live. */
  [
    [
      '   o               o    ',
      '  oo              oo    ',
      '  #yy#            #yy#  ',
      '  #nn#            #nn#  ',
      '  #nn#            #nn#  ',
      '  #yy#            #yy#  ',
      '  #nn#            #nn#  ',
      '  #nn#            #nn#  ',
      '  #nn#            #nn#  ',
      '  #nn#            #nn#  ',
      ' #nnnn#          #nnnn# ',
      'nnnnnnnnnnnnnnnnnnnnnnnn',
      'NNNNNNNNNNNNNNNNNNNNNNNN',
      'nyynnncnnnnnnnnnncnnnyyn',
      'nNnnnnnnnnnnnnnnnnnnnnNn',
      'nnnn################nnnn',
      'n##n#oooooooooooooo#n##n',
      'nPPn#oorrrrrrrrrroo#nPPn',
      'nPPn#orrrryyyyrrrro#nPPn',
      'nppn#rrryyyyyyyyrrr#nppn',
      'nppn#rryyddddddyyrr#nppn',
      'n##n#rrrrrrddrrrrrr#n##n',
      'nNNnnnnnnnnnnnnnnnnnnNNn',
      'NNNNNNNNNNNNNNNNNNNNNNNN',
    ],
    [
      '    o             oo    ',
      '   oo             o     ',
      '  #yy#            #yy#  ',
      '  #nn#            #nn#  ',
      '  #nn#            #nn#  ',
      '  #yy#            #yy#  ',
      '  #nn#            #nn#  ',
      '  #nn#            #nn#  ',
      '  #nn#            #nn#  ',
      '  #nn#            #nn#  ',
      ' #nnnn#          #nnnn# ',
      'nnnnnnnnnnnnnnnnnnnnnnnn',
      'NNNNNNNNNNNNNNNNNNNNNNNN',
      'nyynnnynnnnnnnnnnynnnyyn',
      'nNnnnnnnnnnnnnnnnnnnnnNn',
      'nnnn################nnnn',
      'n##n#ooorrrrrrrrooo#n##n',
      'nPPn#orrryyyyyyrrro#nPPn',
      'nPPn#rryyyyyyyyyyrr#nPPn',
      'nppn#ryyyyyyyyyyyyr#nppn',
      'nppn#ryyyddddddyyyr#nppn',
      'n##n#rrrryrddryrrrr#n##n',
      'nNNnnnnnnnnnnnnnnnnnnNNn',
      'NNNNNNNNNNNNNNNNNNNNNNNN',
    ],
  ],
  /* 14 Deep Tunnel (dwarf) — the NEGATIVE-SPACE one. Not a building at all: a
     near-solid lump of cliff with a ragged, off-centre crown, and the "hall" is
     the black hole bored into it — timber-propped, brass-ended lintel, a lamp
     burning inside. No roofline, no chimney, no outlined arch anywhere on the
     contour. The bottom is not masonry but a rail bed flaring toward the viewer
     with the ore-cart rolling out of the dark. */
  [
    [
      '      nn                ',
      '     nnnnn              ',
      '    nnnnnnnn      nn    ',
      '   nnnnnnnnnn   nnnnnn  ',
      '  nnnnnnnnnnnnnnnnnnnn  ',
      ' nnnnnnnnnnnnnnnnnnnnnn ',
      'nnnNnnnnnnnnnnnnnnnnnnnn',
      'nnnnnnnnnnnnnnnnnnnnnNnn',
      'nnnnnnnnnnnnnnnnnnyynnnn',
      'nnnnnnnncnnnnncnnnnnnnnn',
      'nnnnnnnnnnyyyynnnnnnnnnn',
      'nnnnnnywwwwwwwwwynnnnnnn',
      'nnnnnnnwooooooownnnnnnnn',
      'nnnnnnnwokkkkkownnnnnnnn',
      'nnnnnnnwokkkkkownnyynnnn',
      'nnnnnnnwokkkkkownyynnnnn',
      'nnnnnnnwokkykkownnnnnnnn',
      'nnNnnnnwokkkkkownnnnnNnn',
      'nnnnnnnwo#PPP#ownnnnnnnn',
      'nnnnnnnwo#PPP#ownnnnnnnn',
      'nnnnnnnwo#ppp#ownnnnnnnn',
      'nnnnnnwwodmmmdowwnnnnnnn',
      'nnnnnnbbdbbbbbdbbnnnnnnn',
      'nnnnnbbdbbbbbbbbdbbnnnnn',
    ],
  ],
  /* 15 Rune Hall (dwarf) — the VERTICAL one. A stepped ziggurat: six discrete
     terraces widening from a two-pixel rune flame at the very top to a twenty-two
     pixel plinth at the bottom, so the outline is a staircase pyramid. Fourteen
     of its twenty-four rows are no more than eight pixels wide — nothing else in the
     set is that thin that high. Carved ward-tablet on the middle terrace,
     brass-footed pillars at the base. */
  [
    [
      '           cc           ',
      '          cvvc          ',
      '          #vv#          ',
      '          #nn#          ',
      '         #nccn#         ',
      '         #nNNn#         ',
      '         #nPPn#         ',
      '         #nPPn#         ',
      '         #nppn#         ',
      '        nNNNNNNn        ',
      '        nynnnnyn        ',
      '        ncnnnncn        ',
      '        nnnnnnnn        ',
      '        nNnnnnNn        ',
      '      NNNNNNNNNNNN      ',
      '      nyynnnnnnyyn      ',
      '      nn#vvvvvv#nn      ',
      '      nn#vccccv#nn      ',
      '      nn#vccccv#nn      ',
      '      nn#vvvvvv#nn      ',
      '    NNNNNNNNNNNNNNNN    ',
      '    nnnn#PPPPPP#nnnn    ',
      '  nyynnn#pppppp#nnnyyn  ',
      ' nNNNNNNNNNNNNNNNNNNNNn ',
    ],
  ],
  /* 16 Golem Foundry (dwarf) — the LOPSIDED one. Nothing about it is symmetrical:
     a tall brass-hooped stack jammed hard against the left edge, a squat furnace
     block filling only the left fourteen columns, then a three-pixel gap of open
     ground, then the unfinished golem standing entirely clear of the building on
     the right — its own head, shoulders and two legs, detached from the mass.
     Two frames: furnace and molten runnel. */
  [
    [
      '  oo                    ',
      ' oo o                   ',
      ' #nnn#                  ',
      ' #yyy#                  ',
      ' #nnn#                  ',
      ' #nnn#                  ',
      ' #yyy#                  ',
      ' #nnn#                  ',
      ' #nnn#                  ',
      '#nnnnn#                 ',
      'nnnnnnnnnnnnnn          ',
      'NNNNNNNNNNNNNN    NNNN  ',
      'nyynnnnnnnnyyn    NccN  ',
      'nn##########nn    NNNN  ',
      'nn#oorrrroo#nn   NNNNNN ',
      'nn#orryyrro#nn   NnNNnN ',
      'nn#ryyyyyyr#nn   NnNNnN ',
      'nn#rryyyyrr#nn   NnPPnN ',
      'nn#rrrddrrr#nn   NnNNnN ',
      'nn##########nn   nNNNNn ',
      'nnnnnrrrrnnnnn   nnnnnn ',
      'nnnnyrrrrynnnn   nn  nn ',
      'n#PPPPPPPPPP#n   nn  nn ',
      'NNNNNNNNNNNNNN   nnnnnn ',
    ],
    [
      '   o                    ',
      '  oo o                  ',
      ' #nnn#                  ',
      ' #yyy#                  ',
      ' #nnn#                  ',
      ' #nnn#                  ',
      ' #yyy#                  ',
      ' #nnn#                  ',
      ' #nnn#                  ',
      '#nnnnn#                 ',
      'nnnnnnnnnnnnnn          ',
      'NNNNNNNNNNNNNN    NNNN  ',
      'nyynnnnnnnnyyn    NvvN  ',
      'nn##########nn    NNNN  ',
      'nn#orrrrrro#nn   NNNNNN ',
      'nn#rryyyyrr#nn   NnNNnN ',
      'nn#yyyyyyyy#nn   NnNNnN ',
      'nn#ryyyyyyr#nn   NnPPnN ',
      'nn#rryddyrr#nn   NnNNnN ',
      'nn##########nn   nNNNNn ',
      'nnnnnyyyynnnnn   nnnnnn ',
      'nnnnryyyyrnnnn   nn  nn ',
      'n#PPPPPPPPPP#n   nn  nn ',
      'NNNNNNNNNNNNNN   nnnnnn ',
    ],
  ],
  /* 17 Bowyer Glade (elf) — pale living trunk under a bright canopy, finished bows curing on the branches, woven door-cloth */
  [
    [
      '        gg              ',
      '      ggggg   gg        ',
      '    gGgggggggggggg      ',
      '   ggggggggggggggggg    ',
      '  gggGgggggggggggggg    ',
      '  gggggggggggggGgggggg  ',
      '   ggggggggggggggggggg  ',
      '    GgggggggggggggGgg   ',
      '     gggggqqqqqggggg    ',
      '      ggggqwwqqgggg     ',
      '    ggg  wqqqqqw  ggg   ',
      '    ww  wqqqqqqqw  ww   ',
      '   w  m qqqqqqqqqm  w   ',
      '   w  m qqqqcqqqqm  w   ',
      '   w  m qqqcccqqqm  w   ',
      '    ww  qqqqcqqqq  ww   ',
      '        qqwqqqwqq       ',
      '       qqqbbbbbqqq      ',
      '       qqbPPPPPbqq      ',
      '       qqbPPPPPbqq      ',
      '       qqbpppppbqq      ',
      '       qqbpppppbqq      ',
      '    wqqqqqqqqqqqqqqw    ',
      '  ggwwwqqqqqqqqqqwwwgg  ',
    ],
  ],
  /* 18 Shadow Glade (elf) — drooping dark willow, hanging vine curtains, a hollow lit only by a violet glimmer */
  [
    [
      '         GG             ',
      '      GGGG  GGG         ',
      '    GGGGGGGGGGGGGG      ',
      '  GGGGGGGGGGGGGGGGGG    ',
      '  GGGGoGGGGGGGGGGGGGG   ',
      ' GGGGGGGGGGGGGGGGGGGG   ',
      '  oGGGGGGGGGGGGGGGGGo   ',
      '   GGoGGGGGGGGGGGoGG    ',
      '  GG  GGGGGGGGGG  GG    ',
      '   G  G   GGGG   G G    ',
      '   G  G    GG    G G    ',
      '   o  G    qq    G o    ',
      '      o   qqqq   o      ',
      '         qwwqq          ',
      '         qqwwqqq        ',
      '        qqqbbqqqq       ',
      '        qqbvvbqqq       ',
      '       qqqbooobqqq      ',
      '       qqbooooobqq      ',
      '      qqqbPPPPPbqqq     ',
      '      qqqbPPPPPbqqq     ',
      '     qqqqbpppppbqqqq    ',
      '    qqwqqbpppppbqqwqq   ',
      '  GGwwqqqqqqqqqqqwwGG   ',
    ],
  ],
  /* 19 Moon Grove (elf) — crescent and stars over two slender birches and a carved moonstone standing in a lit pool */
  [
    [
      '         ccc            ',
      '        cc       c      ',
      '       cc               ',
      '       c                ',
      '       cc         c     ',
      '        cc              ',
      '         ccc            ',
      '  ggg                   ',
      ' ggggg           ggg    ',
      ' gGggg          ggggg   ',
      '  ggg           ggGgg   ',
      '   qq            ggg    ',
      '   qq             qq    ',
      '   qq     NNNN    qq    ',
      '   qq     NccN    qq    ',
      '   qq     NccN    qq    ',
      '   qq     NPPN    qq    ',
      '   qw     NPPN    wq    ',
      '   qq     NppN    qq    ',
      '   qq     NNNN    qq    ',
      '   qq   cccccccc  qq    ',
      '  qqqq cccccccccc qqqq  ',
      ' gqqqqgccccccccccgqqqqg ',
      ' ggggggccccccccccgggggg ',
    ],
  ],
  /* 20 Phoenix Aerie (elf) — a woven nest of pale branches high in a tree crown, phoenix-fire burning in its bowl */
  [
    [
      '           r            ',
      '          ryr           ',
      '         ryyyr          ',
      '        ryyyyyr         ',
      '        ryyyyyr         ',
      '       rryyyyyrr        ',
      '       ryyyyyyyr        ',
      '      rryyyyyyyrr       ',
      '     wrryyyyyyyrrw      ',
      '    wwrrryyyyyrrrww     ',
      '   wqwwrrrrrrrrrrwwqw   ',
      '   qwqwwrryyyyrrwwqwq   ',
      '   wqwqwwwrrrrwwwqwqw   ',
      '   qwqwqwwwwwwwwqwqwq   ',
      '    qwqwwwwwwwwwwqwq    ',
      '      wqwwwwwwwwqw      ',
      '      gg  qqqq  gg      ',
      '     ggg  qwwq  ggg     ',
      '    gGgg  qwwq  ggGg    ',
      '     ggg  qPPq  ggg     ',
      '         qqPPqq         ',
      '         qqppqq         ',
      '        qqwppwqq        ',
      '     gwqqqqqqqqqqwg     ',
    ],
  ],
  /* 21 Orc Camp — skull totem beside a great sagging hide lodge, war-paint stripes, twin clan banners */
  [
    [
      '   m                    ',
      '   q                    ',
      ' NNNN                   ',
      ' NkkN                   ',
      ' xNNx                   ',
      '  qq                    ',
      '  qq         q q        ',
      ' NqqN        qEq        ',
      '  qq        EEEEE       ',
      '  qq       EEEEEEE      ',
      '  qq      ExEEExEEE     ',
      '  qq     EEEEEEEEEEE    ',
      '  qq    EExEEEEExEEEE   ',
      '  qq   EEEEEEEEEEEEEEE  ',
      '  qq  EEEEEEEEEEEEEEEEE ',
      '  qq ExxEEEEEEEEEEEExxE ',
      '  qq EPPPEE######EEPPPE ',
      '  qq EPPPEE#oooo#EEPPPE ',
      '  qq EpppEE#oooo#EEpppE ',
      '  qq ExxxEE#oooo#EExxxE ',
      '  qq EEEEEE#oooo#EEEEEE ',
      '  qq bbbbbbbbbbbbbbbbbb ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' bNbbbbbbbbbbbbbbbbbbNb ',
    ],
  ],
  /* 22 Goblin Warren — scrap-plank roof over an earth mound riddled with burrows, rag flag, stolen loot */
  [
    [
      '     m           o      ',
      '     qPPP        o      ',
      '     qPPp       mm      ',
      '     qpp        mm      ',
      '     q          mm      ',
      '     q          mm      ',
      '   qqqqqqq   qqmmqqqq   ',
      '  qqqqqqqqqqqqqqqqqqqq  ',
      ' bqqbqqqqbqqqqqqbqqqqqb ',
      ' qqqqqqqqqqqqqqqqqqqqqq ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' bbqqbbbbbbbbbbbbqqbbbb ',
      ' bb####bbb####bbb####bb ',
      ' bb#oo#bbb#oo#bbb#oo#bb ',
      ' bb#oo#bbb#ii#bbb#oo#bb ',
      ' bb#oo#bbb#kk#bbb#oo#bb ',
      ' bb#oo#bbb#II#bbb#oo#bb ',
      ' bb#oo#bbb#oo#bbb#oo#bb ',
      ' bb####bbb####bbb####bb ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' bybbbbbbbbbybbbbbbbybb ',
      ' bqbbbbbmbbbbbbbqbbbbbb ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
    ],
  ],
  /* 23 Murloc Lagoon — domed hide hut on driftwood stilts, shell trophies, standing in reeds and shallow water */
  [
    [
      '                        ',
      '                        ',
      '        aaaaaaa         ',
      '      aaaaaaaaaaa       ',
      '     aaaaAAAaaaaaa      ',
      '    aaaaaaaaaaaaaaaa    ',
      '   aaAaaaaaaaaaaaAaaa   ',
      '  AAAAAAAAAAAAAAAAAAAA  ',
      '     wwwwwwwwwwwwww     ',
      '     aaaaaaaaaaaaaa     ',
      '     aayya####ayyaa     ',
      '     aAaaa#oo#aaaAa     ',
      '     aaPPa#oo#aPPaa     ',
      '     aaPPa#oo#aPPaa     ',
      '     AAppA#oo#AppAA     ',
      '     wwwwwwwwwwwwww     ',
      '  g   ww        ww   g  ',
      '  gg  ww        ww  gg  ',
      ' cggc ww        ww cggc ',
      ' ccgccwwccccccccwwccgcc ',
      ' ccAcccccccccccccccAccc ',
      ' gccccccccccccccccccccg ',
      ' gAccccccccccccccccccAg ',
      ' ggccccccccccccccccccgg ',
    ],
  ],
  /* 24 Dragon Nest — scorched crag, a bowl of charred branches, three hot eggs, embers in the rock */
  [
    [
      '     n           nn     ',
      '    nnn         nnnn    ',
      '   nnnnn       nnnnnn   ',
      '  nnnnnnn     nnnnnnnn  ',
      '  nnnnnnnn   nnnnnnnnn  ',
      ' nnnnnnnnnnnnnnnnnnnnn  ',
      ' nnnnnnnnnnnnnnnnnnnnnn ',
      ' nnnnnnnnnnnnnnnnnnnnnn ',
      '  bbbbbbbbbbbbbbbbbbbb  ',
      ' bbrbbbbbbbbbbbbbbbrbbb ',
      ' bbb####bb####bb####bbb ',
      ' bbb#PP#bb#PP#bb#PP#bbb ',
      ' bbr#PP#rb#PP#br#PP#rbb ',
      ' bbb#pp#bb#pp#bb#pp#bbb ',
      ' brb####br####rb####brb ',
      ' bbbbrrbbbbrrbbbbrrbbbb ',
      ' bbbbbbbbbbbbbbbbbbbbbb ',
      ' nbbbbbbbbbbbbbbbbbbbbn ',
      ' nnNNnnnnnnnnnnnnnNNnnn ',
      ' nnnnnnnNNnnNNnnnnnnnnn ',
      ' nNnnnnnnnnnnnnnnnnnNnn ',
      ' nnnnNnnrrnnnnrrnnNnnnn ',
      ' nnnnnnnrrnnnnrrnnnnnnn ',
      ' #nnnnnnnnnnnnnnnnnnnn# ',
    ],
  ],
  /* 25 Griffin Nest — two windswept pinnacles with the eyrie slung between them.
     Redrawn: the old version was three stacked full-width bars — pale rock, a
     flat brown slab, pale rock — with a serrated top edge, two orphaned single
     pixels floating above it, four stray 'm' (metal) pixels standing in for rock,
     and eggs drawn as square '#' boxes identical in construction to the Dragon
     Nest's. It was the only structure in the set whose outline was a plain
     rectangle. Now the two pinnacles stay separate for eight rows, so the
     silhouette carries a notch nothing else has; the eyrie is a woven bowl in
     'q' timber laced with bleached 'N', open at the top and tapering to five
     pixels at the base; and the eggs are round. */
  [
    [
      '   N                N   ',
      '  NNN              NNN  ',
      '  NnNN            NNnN  ',
      ' NNNNN            NNNNN ',
      ' NNnNN            NNNNN ',
      ' NNNNN            NNnNN ',
      'NNNNNN            NNNNNN',
      'NNNNnN            NNNNNN',
      'NNNNNN     qq     NNnNNN',
      'NNNNNq    qNNq    qNNNNN',
      'NNNNNqq  qNqqNq  qqNNNNN',
      'NNNNNqNqqNqooqNqqNqNNNNN',
      'NNNNNqqNqoPPooPPoqNqNNNN',
      'NNNNNNqqoPPPoPPPoqqNNNNN',
      'NNNNNNqqoPPPoPPPoqqNNNNN',
      'NNNNNNqNqoppoppoqNqNNNNN',
      'NNNNNNqqqqoooooqqqqNNNNN',
      'NNNNNNNqqNqqqqqNqqNNNNNN',
      'NNNNNNNNqqqqqqqqqNNNNNNN',
      ' NNNNNNNNNqqqqqNNNNNNNN ',
      ' nNNNNNNNNNNNNNNNNNNNNn ',
      '  nnNNNNNNNNNNNNNNNNnn  ',
      '   nnnNNNNNNNNNNNNnnn   ',
      '    nnnnnnnnnnnnnnnn    ',
    ],
  ],
];
